import React from 'react';
import { ENV } from '@/constants';
import { ButtonLink } from '@inpart-io/react-components';
import { HomeIcon } from '@heroicons/react/24/solid';
import Link from 'next/link';
import Logo from '../layout/Logo';

interface homePageHeaderProps {
  loginUrl?: string;
  registerUrl?: string;
}

function HomePageHeader({ loginUrl = '/', registerUrl = '/' }: homePageHeaderProps) {
  return (
    <div className="h-[70px] bg-white flex items-center w-full shadow-light-down z-10 px-5 md:fixed md:top-0">
      <div className="mt-[5px] mr-5">
        <Link href="/" aria-label={`${ENV.NEXT_PUBLIC_ORGANISATION_NAME} home`}>
          <Logo title={`${ENV.NEXT_PUBLIC_ORGANISATION_NAME} Logo`} />
        </Link>
      </div>

      <div className="ml-auto flex items-center">
        <ButtonLink LinkComponent={Link} href={loginUrl} className="mr-2.5">
          Login
        </ButtonLink>
        <ButtonLink LinkComponent={Link} href={registerUrl} className="mr-2.5">
          Register
        </ButtonLink>
        <ButtonLink
          LinkComponent={Link}
          href="/"
          className="mr-2.5 text-content-primary"
          IconLeft={<HomeIcon />}
          variant="tertiary"
        />
      </div>
    </div>
  );
}

export default HomePageHeader;
